import * as types from '../actions/action-types';

export default (state = {
  running: false,
  latestLogs: null,
  latestError: null
}, action) => {
  switch (action.type) {
    case types.APP_LAUNCHED:
      return {
        ...state,
        running: true,
        latestLogs: null,
        latestError: null
      };

    case types.APP_QUIT:
      return {
        ...state,
        running: false,
        latestLogs: action.logs,
        latestError: action.error
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/launch-reducer.js